import React from "react";

import { Button } from "@mui/material";
import InputSelectionComponent from "../Dashboard/Component/inputSelection";

import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import RadioButtonsGroup from "../../Component/UI/RadioGroup/RadioGroup";
import { ENTITY_LABELS } from "../../utils/labelMapping";


const DashboardNav = ({
  selectedOptionShow,
  contentTypes,
  brandItems,
  selectedBrandItems,
  handleBrandCheckChange,
  handleProductCheckChange,
  selectedProductItems,
  productItems,
  isFirstTime,
  selectedPersona,
  handlePersonaCheckChange,
  personas,
  selectedGeographyItems,
  handleGeographyCheckChange,
  geography,
  selectedMarketItems,
  handleMarketCheckChange,
  markets,
  selectedLlmItems,
  handleLlmCheckChange,
  dbLlms,
  showData,
  isDone,
  handleClickShow,
  filterModalType,
  showNav = true,
  setSelectedOptionShow,
  categories,
  handleCategoryCheckChange,
  selectedCategory,
  isDisabled = false,
  isSharedView = false,
  onStartNew,
}) => {
  const RADIO_OPTIONS = [
  {
    value: "Company/Brand",
    label: ENTITY_LABELS.brand,
  },
  {
    value: "Product",
    label: ENTITY_LABELS.product,
  },
];
  const handleTypeChange = (value) => {
    setSelectedOptionShow(value);
  };
  return (
    <>
      <div>
        <RadioButtonsGroup
          options={RADIO_OPTIONS}
          onChange={handleTypeChange}
          disabled={isDisabled}
          selectedvalue={selectedOptionShow}
        />
      </div>

      <div className="customTabContent tab-content" id="nav-tabContent">
        <div
          className="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="nav-competition-tab"
        >
          <div className="row">
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-briefcase"></i>
                </span>
                {selectedOptionShow === "Company/Brand" ? (
                  <InputSelectionComponent
                    options={brandItems}
                    selectedOptions={selectedBrandItems}
                    handleChange={handleBrandCheckChange}
                    disabled={isDisabled}
                    // type="brand"
                  />
                ) : (
                  <InputSelectionComponent
                    options={productItems}
                    selectedOptions={selectedProductItems}
                    handleChange={handleProductCheckChange}
                    disabled={isDisabled}
                    // type="product"
                  />
                )}
              </div>
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedCategory}
                  handleChange={handleCategoryCheckChange}
                  options={categories}
                  disabled={isDisabled}
                  // type="category"
                />
              </div>
            </div>
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedPersona}
                  handleChange={handlePersonaCheckChange}
                  options={personas}
                  disabled={isDisabled}
                  // type="persona"
                />
              </div>
            </div>

                   <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedGeographyItems}
                  handleChange={handleGeographyCheckChange}
                  options={geography}
                  type="geography"
                  disabled={isDisabled}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1">
     
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedMarketItems}
                  handleChange={handleMarketCheckChange}
                  options={markets}
                  type="market"
                  disabled={isDisabled}
                />
              </div>
            </div>
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-target"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedLlmItems}
                  handleChange={handleLlmCheckChange}
                  options={dbLlms}
                  type="llm"
                  disabled={isDisabled}
                />
              </div>
            </div>

            <div className="col-md-4 d-flex align-items-start gap-2">
              {!isSharedView ? (
                <Button
                  disabled={isFirstTime || (!showData && !isDone) || isDisabled}
                  style={{
                    backgroundColor: "gainsboro",
                    borderColor: "gainsboro",
                    color: "black",
                    // textTransform: "capitalize",
                  }}
                  variant="contained"
                  color={"secondary"}
                  onClick={handleClickShow}
                >
                  Get Input
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onStartNew}
                  sx={{ textTransform: "none" }}
                >
                  Start New
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardNav;
